var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('loader'):_c('tile-grid',_vm._l((_vm.$store.state.snapshot.snapshots),function(snapshot){return _c('snapshot-tile',{key:snapshot.id,attrs:{"snapshot":snapshot},on:{"tile-clicked":function($event){return _vm.tileClicked(snapshot)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }